import React, { useEffect, useState } from 'react';
import { useOfflineDetection } from '../hooks/useOfflineDetection';
import './OfflineIndicator.css';

interface OfflineIndicatorProps {
  showReconnectedMessage?: boolean;
  autoHideDelay?: number;
}

const OfflineIndicator: React.FC<OfflineIndicatorProps> = ({
  showReconnectedMessage = true,
  autoHideDelay = 3000,
}) => {
  const { isOnline, isOffline, wasOffline, resetOfflineState } = useOfflineDetection();
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (isOnline && wasOffline && showReconnectedMessage) {
      setShowReconnected(true);
      
      const timer = setTimeout(() => {
        setShowReconnected(false);
        resetOfflineState();
      }, autoHideDelay);

      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline, showReconnectedMessage, autoHideDelay, resetOfflineState]);

  if (showReconnected) {
    return (
      <div className="offline-indicator online">
        <div className="offline-indicator-content">
          <svg className="offline-indicator-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 12 2 2 4-4"/>
            <circle cx="12" cy="12" r="10"/>
          </svg>
          <span>Back online</span>
        </div>
      </div>
    );
  }

  if (isOffline) {
    return (
      <div className="offline-indicator offline">
        <div className="offline-indicator-content">
          <svg className="offline-indicator-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6"/>
            <path d="m16.24 7.76-1.41 1.41"/>
            <path d="M6 12h6"/>
            <path d="m7.76 16.24 1.41-1.41"/>
            <path d="M12 18v6"/>
          </svg>
          <span>You're offline</span>
          <small>Some features may not be available</small>
        </div>
      </div>
    );
  }

  return null;
};

export default OfflineIndicator;